import { render, staticRenderFns } from "./ThePage.vue?vue&type=template&id=56d4f102&"
import script from "./ThePage.vue?vue&type=script&lang=js&"
export * from "./ThePage.vue?vue&type=script&lang=js&"
import style0 from "./ThePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports